<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-card style="">
            <v-card-text>
              <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Custom Clearance > Export</h3>
                <v-btn flat class="primary" style="margin-left:700px;margin-bottom: 10px" v-on:click="back()">Back</v-btn>
              </v-layout>
              <v-layout row wrap align-center style="margin-top:20px;">
                <v-btn v-on:click="sho1(); activate(1);" :class="['active_el', (active_el === 1 ) ? 'active_el' : 'primary']" flat style="margin-left: 300px">Basic Info</v-btn>
                <v-btn v-on:click="sho2(); activate(2); " :class="[(active_el === 2 ) ? 'active_el' : 'primary']" flat style="margin-left: 20px">Container Info</v-btn>
                <v-btn v-on:click="sho3(); activate(3); " :class="[(active_el === 3 ) ? 'active_el' : 'primary']" flat style="margin-left: 20px">Documents</v-btn>
                <v-btn v-on:click="sho5(); activate(5); " :class="[(active_el === 5 ) ? 'active_el' : 'primary']" flat style="margin-left: 20px">Review</v-btn>
              </v-layout>
              <v-flex xs12 v-show="show1">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Book New Shipment</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex>
                          <label style="margin-right: 10px">Booking Date</label>
                          <v-menu
                            ref="menu"
                            :close-on-content-click="false"
                            v-model="menu"
                            :nudge-right="40"
                            :return-value.sync="date"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            style="margin-left:20px"
                          >
                            <v-text-field
                              slot="activator"
                              v-model="date"
                              label="Select Date"
                              prepend-icon="event"
                              readonly
                            ></v-text-field>
                            <v-date-picker v-model="date" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                              <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Booking Reference</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Sales Order No</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show1">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Booking Type</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs6 style="margin-left:20px">
                          <v-layout row wrap>
                            <v-radio-group v-model="bookinggroup">
                              <v-radio
                                :label="`Back to Back(B2B)`"
                                :value="B2B"
                              ></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 style="margin-left:20px">
                          <label style="margin-right: 10px">Terms of Shipment</label>
                           <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                       <v-flex>
                         <label style="margin-right: 10px">From</label>
                       </v-flex>
                       <v-flex>
                         <label style="margin-right: 10px">To</label>
                       </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex>
                          <label style="margin-right: 10px">Place of Receipt</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Port of Loading</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Place of Delivery</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">To (Port of Discharge)</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show1">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Haulage Details</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs2></v-flex>
                        <v-flex xs4>
                          <h3 style="margin-top:20px;margin-bottom:20px">Ship From</h3>
                          <label style="margin-right: 10px">Company Name</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-right: 10px">Company Address</label>
                          <v-textarea
                            outline
                            name="input"
                            label=""
                            value=""
                            style=""
                          ></v-textarea>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Requested Empty Positioning</label>
                              <v-menu
                                ref="menu1"
                                :close-on-content-click="false"
                                v-model="menu1"
                                :nudge-right="40"
                                :return-value.sync="date1"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                                style="margin-left:20px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="date1"
                                  label="Select Date"
                                  prepend-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker v-model="date1" no-title scrollable>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="menu1 = false">Cancel</v-btn>
                                  <v-btn flat color="primary" @click="$refs.menu1.save(date1)">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Time</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Requested Full Pickup Date</label>
                              <v-menu
                                ref="menu2"
                                :close-on-content-click="false"
                                v-model="menu2"
                                :nudge-right="40"
                                :return-value.sync="date2"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                                style="margin-left:20px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="date2"
                                  label="Select Date"
                                  prepend-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker v-model="date2" no-title scrollable>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="menu2 = false">Cancel</v-btn>
                                  <v-btn flat color="primary" @click="$refs.menu2.save(date2)">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Time</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Contact Phone Number</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Contact</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 style="margin-left:20px">
                          <h3 style="margin-top:20px;margin-bottom:20px;">Ship To</h3>
                          <label style="margin-right: 10px">Company Name</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-right: 10px">Company Address</label>
                          <v-textarea
                            outline
                            name="input"
                            label=""
                            value=""
                            style=""
                          ></v-textarea>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Requested Delivery Date</label>
                              <v-menu
                                ref="menu3"
                                :close-on-content-click="false"
                                v-model="menu3"
                                :nudge-right="40"
                                :return-value.sync="date3"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px"
                                style="margin-left:20px"
                              >
                                <v-text-field
                                  slot="activator"
                                  v-model="date3"
                                  label="Select Date"
                                  prepend-icon="event"
                                  readonly
                                ></v-text-field>
                                <v-date-picker v-model="date3" no-title scrollable>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="menu3 = false">Cancel</v-btn>
                                  <v-btn flat color="primary" @click="$refs.menu3.save(date3)">OK</v-btn>
                                </v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Time</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Contact Phone Number</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Contact</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show1">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Vessel Information</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex>
                          <label style="margin-right: 10px">Departure Date</label>
                          <v-menu
                            ref="menu4"
                            :close-on-content-click="false"
                            v-model="menu4"
                            :nudge-right="40"
                            :return-value.sync="date4"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            style="margin-left:20px"
                          >
                            <v-text-field
                              slot="activator"
                              v-model="date4"
                              label="Select Date"
                              prepend-icon="event"
                              readonly
                            ></v-text-field>
                            <v-date-picker v-model="date4" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn flat color="primary" @click="menu4 = false">Cancel</v-btn>
                              <v-btn flat color="primary" @click="$refs.menu4.save(date4)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Departure Time</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Vessel</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Voyage</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs3 style="margin-left:900px;margin-top:20px" v-show="show1">
                    <v-btn class="primary" style="margin-left:20px">Next</v-btn>
                </v-flex>
                <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Select Special Conditions</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-checkbox
                          v-model="Reefer"
                          :label="`Reefer`"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="Hazardous"
                          :label="`Hazardous`"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="Oversized"
                          :label="`Oversized`"
                        ></v-checkbox>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs1 style="margin-left:20px"></v-flex>
                        <v-flex xs3 style="margin-left:20px">
                          <label style="margin-right: 10px">Container Type</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                          <label style="margin-right: 10px">Qty</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-right: 10px">Commodity</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex xs3 style="margin-left:20px"></v-flex>
                        <v-flex xs3 style="margin-left:0px">
                          <label style="margin-right: 10px">Net. Wt | M Tons | Per Cont</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-right: 10px">Gross Wt | M Tons | Per Cont</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-left:20px"><v-icon>add_circle</v-icon><v-icon style="margin-left:20px">remove_circle</v-icon></label>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6 style="margin-left:0px">
                          <v-layout row wrap>
                            <v-checkbox
                              v-model="cargo"
                              :label="'I want to allocate my cargo'"
                            ></v-checkbox>
                            <v-btn class="primary" style="margin-left:0px">Allocate Cargo</v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Reefer Details</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Temperature(C)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">No. of Probes</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Ventilation (m3/Hour)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Humidity (%)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-checkbox
                          v-model="ColdTreatement"
                          :label="'Cold Treatement'"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="GensetExport"
                          :label="'Genset Export'"
                        ></v-checkbox>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Hazardous Details</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs2></v-flex>
                        <v-flex xs4>
                          <label style="margin-right: 10px">IMO Class</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                          <v-layout row wrap>
                            <v-flex xs3 style="margin-left: 10px">
                              <label style="margin-right: 10px">UN Code</label>
                              <v-text-field
                                label="Please Mention"
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs3 style="margin-left: 10px">
                              <label style="margin-right: 10px">Flash Point</label>
                              <v-text-field
                                label="Please Mention"
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs3 style="margin-left: 10px">
                              <label style="margin-right: 10px">Unit Type *</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label="Please Mention"
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                          </v-layout>
                            <label style="margin-right: 10px">Proper Shipping</label>
                            <v-text-field
                              label="Please Mention"
                              outline
                              style="margin-top:10px"
                            ></v-text-field>
                            <label style="margin-right: 10px">Proper Shipping</label>
                            <v-textarea
                              outline
                              name="input"
                              label=""
                              value=""
                              style=""
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs4 style="margin-left: 30px">
                          <label style="margin-right: 10px">IMO Class 2</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <label style="margin-right: 10px">Packing Group</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label="Please Mention"
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                            <v-flex xs4 style="margin-left:10px">
                              <label style="margin-right: 10px">Aggregation State</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label="Please Mention"
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <label style="margin-right: 10px">Marine Pollutant</label>
                              <v-text-field
                              label="Please Mention"
                              outline
                              style="margin-top:10px"
                            ></v-text-field>
                            </v-flex>
                            <v-flex xs6 style="margin-left:10px">
                              <label style="margin-right: 10px">Ltd. Qty of Dang Goods</label>
                              <v-text-field
                              label="Please Mention"
                              outline
                              style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <label style="margin-right: 10px">Emergency Contact</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-right: 10px">Emergency Contact Number(Free Dial is not allowed) *</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Oversized Details</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-checkbox
                          v-model="allOversized"
                          :label="`All Oversized Cargo Details`"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="alldetails"
                          :label="`No. I Special all Details at Container`"
                        ></v-checkbox>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Length | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Width | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Height | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-checkbox
                          v-model="allOversized1"
                          :label="`All Oversized Cargo Details`"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="alldetails1"
                          :label="`No. I Special all Details at Container`"
                        ></v-checkbox>
                      </v-layout>
                      <v-divider divider: true></v-divider>
                      <h3 style="margin-top:20px;text-align: left">Container 1</h3>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Length | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Width | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Height | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-divider divider: true></v-divider>
                      <h3 style="margin-top:20px;text-align: left">Container 2</h3>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Length | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Width | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Height | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 v-show="show2">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Allocate Cargo Details</h3>
                      <v-divider divider: true></v-divider>
                      <h3 style="text-align: left;margin-bottom: 10px;margin-top:10px">Container 1</h3>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Container Number</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Container Type</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Commodity</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Agreed Free Days</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">No. of Packages</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Kind of Packages</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Net Wt.(M Tons)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Gross Wt.(M Tons)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Tare Wt.(M Tons)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">VGM Wt.(M Tons)</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Shipper Seal</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">HS Code (Optional)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-flex xs4 style="margin-left:10px">
                        <label style="margin-right: 10px">Cargo Description</label>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                      <v-divider divider: true></v-divider>
                      <h3 style="text-align: left;margin-bottom: 10px;margin-top:10px">Container 2</h3>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Container Number</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Container Type</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Commodity</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Agreed Free Days</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">No. of Packages</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Kind of Packages</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Net Wt.(M Tons)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Gross Wt.(M Tons)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Tare Wt.(M Tons)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">VGM Wt.(M Tons)</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Shipper Seal</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">HS Code (Optional)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-flex xs4 style="margin-left:10px">
                        <label style="margin-right: 10px">Cargo Description</label>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                    </v-card-text>
                  </v-card>
              </v-flex>
              <v-flex xs3 style="margin-left:900px;margin-top:20px" v-show="show2">
                <v-layout row wrap>
                  <v-btn class="primary">Previous</v-btn>
                  <v-btn class="primary" style="margin-left:20px">Next</v-btn>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-show="show3">
                <v-card style="margin-left:30px;margin-top:20px">
                  <v-card-text>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex xs4 style="margin-left:10px">
                        <label style="margin-right: 10px">Contract Number</label>
                        <v-layout row wrap style="margin-top:10px">
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <v-btn class="primary" style="margin-left:10px;margin-top:20px">Verify</v-btn>
                        </v-layout>
                      </v-flex>
                      <v-flex xs4 style="margin-left:20px">
                        <label style="margin-right: 10px">Book On Tarrif</label>
                        <v-checkbox
                          v-model="tarrifbooking"
                          :label="`Don't have CN. Click Checkbox for Tarrif Booking`"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs3 style="margin-left:20px">
                        <label style="margin-right: 10px">Intransit Insurance</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;"
                          outline
                        ></v-overflow-btn>
                      </v-flex>
                    </v-layout>
                    <v-divider divider: true></v-divider>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex xs2></v-flex>
                      <v-flex xs4>
                        <label style="margin-right: 10px">Shipper</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;"
                          outline
                        ></v-overflow-btn>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                        <v-btn class="primary" style="margin-top:20px">Add Additional Parties</v-btn>
                      </v-flex>
                      <v-flex xs4 style="margin-left:30px">
                        <label style="margin-right: 10px">Consignee</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;"
                          outline
                        ></v-overflow-btn>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                    <v-divider divider: true style="margin-top: 20px;margin-bottom: 20px"></v-divider>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex xs2></v-flex>
                      <v-flex xs4>
                        <label style="margin-right: 10px">First Notify Party</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;"
                          outline
                        ></v-overflow-btn>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs4 style="margin-left: 30px">
                        <label style="margin-right: 10px">Second Notify Party</label>
                        <v-text-field
                          label="Please Mention"
                          outline
                          style="margin-top:10px"
                        ></v-text-field>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                    <v-divider divider: true style="margin-top: 20px;margin-bottom: 20px"></v-divider>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex xs2></v-flex>
                      <v-flex xs4>
                        <label style="margin-right: 10px">Contact Person</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;margin-bottom: 20px"
                          outline
                        ></v-overflow-btn>
                        <label style="margin-right: 10px;">General Comments</label>
                        <v-text-field
                          label="Please Mention"
                          outline
                          style="margin-top:10px"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 style="margin-left: 30px">
                        <label style="margin-right: 10px">Mobile Number</label>
                        <v-text-field
                          label="If any..."
                          outline
                          style="margin-top:10px"
                        ></v-text-field>
                        <label style="margin-right: 10px">Send Email regarding Status Update Regarding this Booking Partner Notification (Upto 3 Emails Separated by Commas)</label>
                        <v-text-field
                          label="Please Mention"
                          outline
                          style="margin-top:10px"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 v-show="show3">
                <v-card style="margin-left:30px;margin-top:20px">
                  <v-card-text>
                    <h3 style="text-align: left;margin-bottom: 10px">Upload The Following Documents</h3>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex>
                        <v-checkbox
                          v-model="Commercialinvoice"
                          :label="'Commercial Invoice'"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex>
                        <v-btn>Choose File</v-btn>
                      </v-flex>
                      <v-flex style="margin-left:20px">
                        <v-checkbox
                          v-model="Packinglist"
                          :label="'Packing List'"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex>
                        <v-btn>Choose File</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex>
                        <v-checkbox
                          v-model="billoflading"
                          :label="'Bill of Lading'"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex style="margin-left:90px">
                        <v-btn>Choose File</v-btn>
                      </v-flex>
                      <v-flex style="margin-left:30px">
                        <v-checkbox
                          v-model="certificateoforigin"
                          :label="'Certificate of Origin'"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex style="margin-left:0px">
                        <v-btn>Choose File</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex>
                        <v-checkbox
                          v-model="receiveddatetime"
                          :label="'Original Doc. Received Date and Time'"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex style="margin-left:20px">
                        <v-menu
                            ref="menu5"
                            :close-on-content-click="false"
                            v-model="menu5"
                            :nudge-right="40"
                            :return-value.sync="date5"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                            style="margin-left:20px"
                          >
                            <v-text-field
                              slot="activator"
                              v-model="date5"
                              label="Select Date"
                              prepend-icon="event"
                              readonly
                            ></v-text-field>
                            <v-date-picker v-model="date5" no-title scrollable>
                              <v-spacer></v-spacer>
                              <v-btn flat color="primary" @click="menu5 = false">Cancel</v-btn>
                              <v-btn flat color="primary" @click="$refs.menu5.save(date5)">OK</v-btn>
                            </v-date-picker>
                          </v-menu>
                      </v-flex>
                      <v-flex style="margin-left:30px">
                        <v-text-field
                            label="Time"
                            outline
                            style="margin-top:10px"
                        ></v-text-field>
                      </v-flex>
                      <v-flex style="margin-left:0px;margin-top:20px">
                        <label style="margin-left:20px;margin-top:-20px"><v-icon style="font-size:40px;color:green;">add_circle</v-icon>Add Another Document</label>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex style="margin-left: -20px">
                        <label>Mention Doc. Type</label>
                      </v-flex>
                      <v-flex style="margin-left:30px">
                        <v-text-field
                            label="Please Mention Document Name"
                            outline
                            style="margin-top:10px"
                        ></v-text-field>
                      </v-flex>
                      <v-flex style="margin-left:0px;margin-top:20px">
                        <v-flex style="margin-left:0px">
                          <v-btn>Choose File</v-btn>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs3 style="margin-left:900px;margin-top:20px" v-show="show3">
                <v-layout row wrap>
                  <v-btn class="primary">Previous</v-btn>
                  <v-btn class="primary" style="margin-left:20px">Next</v-btn>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-show="show5">
                <v-card style="margin-left:30px;margin-top:20px">
                  <v-card-text>
                    <h3 style="text-align: left;margin-bottom: 10px">Booking Review</h3>
                    <v-divider divider: true></v-divider>
                    <v-layout row wrap style="margin-top:20px">
                        <v-flex>
                          <label style="margin-right: 10px">Booking Date</label>
                          <v-text-field
                              v-model="date"
                              prepend-icon="event"
                              readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Booking Reference</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Sales Order No</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Material</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex>
                          <label style="margin-right: 10px">Batch</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Quantity in Tons</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Container Stuffing Location</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Shipping Line</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 v-show="show5">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Booking Type</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs6 style="margin-left:20px">
                          <v-layout row wrap>
                            <v-radio-group v-model="bookinggroup">
                              <v-radio
                                :label="`Regular Booking`"
                                :value="B2B"
                              ></v-radio>
                              <v-radio
                                :label="`HUB`"
                                :value="HUB"
                              ></v-radio>
                            </v-radio-group>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 style="margin-left:20px">
                          <label style="margin-right: 10px">Terms of Shipment</label>
                           <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                       <v-flex>
                         <label style="margin-right: 10px">From</label>
                       </v-flex>
                       <v-flex>
                         <label style="margin-right: 10px">To</label>
                       </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex>
                          <label style="margin-right: 10px">Place of Receipt</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Port of Loading</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">Place of Delivery</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                        <v-flex style="margin-left:20px">
                          <label style="margin-right: 10px">To (Port of Discharge)</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show5">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Haulage Details</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs2></v-flex>
                        <v-flex xs4>
                          <h3 style="margin-top:20px;margin-bottom:20px">Ship From</h3>
                          <label style="margin-right: 10px">Company Name</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-right: 10px">Company Address</label>
                          <v-textarea
                            outline
                            name="input"
                            label=""
                            value=""
                            style=""
                          ></v-textarea>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Requested Empty Positioning</label>
                              <v-text-field
                                v-model="date1"
                                prepend-icon="event"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Time</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Requested Full Pickup Date</label>
                              <v-text-field
                                v-model="date2"
                                prepend-icon="event"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Time</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Contact Phone Number</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Contact</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs4 style="margin-left:20px">
                          <h3 style="margin-top:20px;margin-bottom:20px;">Ship To</h3>
                          <label style="margin-right: 10px">Company Name</label>
                          <v-text-field
                            label=""
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-right: 10px">Company Address</label>
                          <v-textarea
                            outline
                            name="input"
                            label=""
                            value=""
                            style=""
                          ></v-textarea>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Requested Delivery Date</label>
                              <v-text-field
                                v-model="date3"
                                prepend-icon="event"
                                readonly
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Time</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <label style="margin-right: 10px">Contact Phone Number</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs4 style="margin-left:20px">
                              <label style="margin-right: 10px">Contact</label>
                              <v-text-field
                                label=""
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show5">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Container Details</h3>
                      <v-divider divider: true></v-divider>
                      <p style="margin-top:20px"> Empty Containers Expected to be Available to pick at Container Yard in Vishakhapatnam, India</p>
                      <v-data-table
                        :headers="headers"
                        :items="desserts"
                        class="elevation-1"
                        style="width:1200px"
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.no}}</td>
                          <td class="text-xs-left">{{ props.item.container}}</td>
                          <td class="text-xs-left">{{ props.item.commodity}}</td>
                          <td class="text-xs-left">{{ props.item.netwt}}</td>
                          <td class="text-xs-left">{{ props.item.grosswt}}</td>
                          <td class="text-xs-left">{{ props.item.tarewt}}</td>
                          <td class="text-xs-left">{{ props.item.vgmwt}}</td>
                          <td class="text-xs-left">{{ props.item.reefer}}</td>
                          <td class="text-xs-left">{{ props.item.hazardous}}</td>
                          <td class="text-xs-left">{{ props.item.oversized}}</td>
                        </template>
                      </v-data-table>
                      <h3 style="text-align: left;margin-bottom: 10px;margin-top:20px">Reefer Details</h3>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Temperature(C)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">No. of Probes</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Ventilation (m3/Hour)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Humidity (%)</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap style="margin-top:20px">
                        <v-checkbox
                          v-model="ColdTreatement"
                          :label="'Cold Treatement'"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="GensetExport"
                          :label="'Genset Export'"
                        ></v-checkbox>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show5">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Hazardous Details</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex xs2></v-flex>
                        <v-flex xs4>
                          <label style="margin-right: 10px">IMO Class</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                          <v-layout row wrap>
                            <v-flex xs3 style="margin-left: 10px">
                              <label style="margin-right: 10px">UN Code</label>
                              <v-text-field
                                label="Please Mention"
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs3 style="margin-left: 10px">
                              <label style="margin-right: 10px">Flash Point</label>
                              <v-text-field
                                label="Please Mention"
                                outline
                                style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs3 style="margin-left: 10px">
                              <label style="margin-right: 10px">Unit Type *</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label="Please Mention"
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                          </v-layout>
                            <label style="margin-right: 10px">Proper Shipping</label>
                            <v-text-field
                              label="Please Mention"
                              outline
                              style="margin-top:10px"
                            ></v-text-field>
                            <label style="margin-right: 10px">Proper Shipping</label>
                            <v-textarea
                              outline
                              name="input"
                              label=""
                              value=""
                              style=""
                            ></v-textarea>
                        </v-flex>
                        <v-flex xs4 style="margin-left: 30px">
                          <label style="margin-right: 10px">IMO Class 2</label>
                          <v-overflow-btn
                            :items="dropdown_list"
                            label="Please Mention"
                            target="#dropdown-example"
                            style="margin-top:10px;"
                            outline
                          ></v-overflow-btn>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <label style="margin-right: 10px">Packing Group</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label="Please Mention"
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                            <v-flex xs4 style="margin-left:10px">
                              <label style="margin-right: 10px">Aggregation State</label>
                              <v-overflow-btn
                                :items="dropdown_list"
                                label="Please Mention"
                                target="#dropdown-example"
                                style="margin-top:10px;"
                                outline
                              ></v-overflow-btn>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs4>
                              <label style="margin-right: 10px">Marine Pollutant</label>
                              <v-text-field
                              label="Please Mention"
                              outline
                              style="margin-top:10px"
                            ></v-text-field>
                            </v-flex>
                            <v-flex xs6 style="margin-left:10px">
                              <label style="margin-right: 10px">Ltd. Qty of Dang Goods</label>
                              <v-text-field
                              label="Please Mention"
                              outline
                              style="margin-top:10px"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <label style="margin-right: 10px">Emergency Contact</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                          <label style="margin-right: 10px">Emergency Contact Number(Free Dial is not allowed) *</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show5">
                  <v-card style="margin-left:30px;margin-top:20px">
                    <v-card-text>
                      <h3 style="text-align: left;margin-bottom: 10px">Oversized Details</h3>
                      <v-divider divider: true></v-divider>
                      <v-layout row wrap style="margin-top:20px">
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Length | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Width | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                        <v-flex style="margin-left:10px">
                          <label style="margin-right: 10px">Height | Meter | Per Container</label>
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-show="show5">
                <v-card style="margin-left:30px;margin-top:20px">
                  <v-card-text>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex xs4 style="margin-left:10px">
                        <label style="margin-right: 10px">Contract Number</label>
                        <v-layout row wrap style="margin-top:10px">
                          <v-text-field
                            label="Please Mention"
                            outline
                            style="margin-top:10px"
                          ></v-text-field>
                        </v-layout>
                      </v-flex>
                      <v-flex xs4 style="margin-left:20px">
                        <label style="margin-right: 10px">Book On Tarrif</label>
                        <v-checkbox
                          v-model="tarrifbooking"
                          :label="`Don't have CN. Click Checkbox for Tarrif Booking`"
                        ></v-checkbox>
                      </v-flex>
                      <v-flex xs3 style="margin-left:20px">
                        <label style="margin-right: 10px">Contract Number</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;"
                          outline
                        ></v-overflow-btn>
                      </v-flex>
                    </v-layout>
                    <v-divider divider: true></v-divider>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex xs2></v-flex>
                      <v-flex xs4>
                        <label style="margin-right: 10px">Shipper</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;"
                          outline
                        ></v-overflow-btn>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs4 style="margin-left:30px">
                        <label style="margin-right: 10px">Consignee</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;"
                          outline
                        ></v-overflow-btn>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                    <v-divider divider: true style="margin-top: 20px;margin-bottom: 20px"></v-divider>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex xs2></v-flex>
                      <v-flex xs4>
                        <label style="margin-right: 10px">First Notify Party</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;"
                          outline
                        ></v-overflow-btn>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs4 style="margin-left: 30px">
                        <label style="margin-right: 10px">Second Notify Party</label>
                        <v-text-field
                          label="Please Mention"
                          outline
                          style="margin-top:10px"
                        ></v-text-field>
                        <v-textarea
                          outline
                          name="input"
                          label=""
                          value=""
                          style=""
                        ></v-textarea>
                      </v-flex>
                    </v-layout>
                    <v-divider divider: true style="margin-top: 20px;margin-bottom: 20px"></v-divider>
                    <v-layout row wrap style="margin-top:20px">
                      <v-flex xs2></v-flex>
                      <v-flex xs4>
                        <label style="margin-right: 10px">Contact Person</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label="Please Mention"
                          target="#dropdown-example"
                          style="margin-top:10px;margin-bottom: 20px"
                          outline
                        ></v-overflow-btn>
                        <label style="margin-right: 10px;">General Comments</label>
                        <v-text-field
                          label="Please Mention"
                          outline
                          style="margin-top:10px"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4 style="margin-left: 30px">
                        <label style="margin-right: 10px">Mobile Number</label>
                        <v-text-field
                          label="If any..."
                          outline
                          style="margin-top:10px"
                        ></v-text-field>
                        <label style="margin-right: 10px">Send Email regarding Status Update Regarding this Booking Partner Notification (Upto 3 Emails Separated by Commas)</label>
                        <v-text-field
                          label="Please Mention"
                          outline
                          style="margin-top:10px"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-divider divider: true style="margin-top: 20px;margin-bottom: 20px"></v-divider>
                    <v-layout row wrap style="margin-top:20px">
                      <h3 style="text-align: left;margin-bottom: 10px">Scanned Documents Enclosed Files</h3>
                      <v-layout row wrap style="margin-top:40px">
                        <v-checkbox
                          v-model="comercialinvoice"
                          label="Commercial Invoice"
                          style="margin-left:-150px"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="billoflading"
                          label="Bill of Lading"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="Packinglist"
                          label="Packing List"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="certificateoforigin"
                          label="Certificate of Origin "
                        ></v-checkbox>
                      </v-layout>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 style="margin-top:20px" v-show="show5">
                <v-card>
                  <v-card-text>
                    <h3 style="margin-top:20px;margin-left: 20px;text-align: left">Save as a Template (For Future Use)</h3>
                    <v-flex xs4>
                      <v-layout row wrap style="margin-top:0px;margin-left: 20px">
                        <v-checkbox
                          v-model="savetemplate"
                        ></v-checkbox>
                        <v-text-field
                          label="Please Mention Template Name"
                          outline
                          style="margin-top:10px;margin-left: -50px"
                        ></v-text-field>
                      </v-layout>
                    </v-flex>
                    <v-btn class="primary" style="margin-left:500px;">Make Corrrections</v-btn>
                    <v-btn class="primary" style="margin-left:20px;" v-on:click="dialog = true">Book Shipment</v-btn>
                    <v-layout row wrap style="margin-top:0px">
                                <v-dialog
                                    v-model="dialog"
                                    width="800"
                                  >
                                    <v-card>
                                      <v-card-text>
                                        <v-layout row wrap>
                                          <v-flex xs12>
                                            <v-layout row wrap>
                                              <v-flex style="">
                                                <v-icon dark right style="color:green;font-size: 50px">check_circle</v-icon>
                                                <h3 style="margin-top:20px;text-align: center;font-size: 22px">GOOD JOB</h3>
                                                <p style="text-align: center;margin-top:20px"><b>Your Booking Number : AME | FF | 236589741</b></p>
                                              </v-flex>
                                            </v-layout>
                                          </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                      <v-divider></v-divider>
                                      <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          color="primary"
                                          flat
                                          @click="dashboard()"
                                        >
                                          Dashboard
                                        </v-btn>
                                        <v-btn
                                          color="primary"
                                          @click="dialog = false"
                                        >
                                          Download PDF
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-dialog>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      items: [1, 2, 3, 4, 5],
      dropdown_list: [1, 2, 3, 4, 5],
      bookinggroup: 1,
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Container', value: 'container' },
        { text: 'Commodity', value: 'commodity' },
        { text: 'Net Wt', value: 'netwt' },
        { text: 'Gross Wt', value: 'grosswt' },
        { text: 'Tare Wt', value: 'tarewt' },
        { text: 'VGM Wt', value: 'vgmwt' },
        { text: 'Reefer', value: 'reefer' },
        { text: 'Hazardous', value: 'hazardous' },
        { text: 'Oversized', value: 'oversized' }
      ],
      desserts: [
        {
          no: '1',
          container: '',
          commodity: '',
          netwt: '',
          grosswt: '',
          tarewt: '',
          vgmwt: '',
          reefer: '',
          hazardous: '',
          oversized: ''
        },
        {
          no: '2',
          container: '',
          commodity: '',
          netwt: '',
          grosswt: '',
          tarewt: '',
          vgmwt: '',
          reefer: '',
          hazardous: '',
          oversized: ''
        },
        {
          no: '3',
          container: '',
          commodity: '',
          netwt: '',
          grosswt: '',
          tarewt: '',
          vgmwt: '',
          reefer: '',
          hazardous: '',
          oversized: ''
        }
      ],
      show1: true,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      date: new Date().toISOString().substr(0, 10),
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      date3: new Date().toISOString().substr(0, 10),
      date4: new Date().toISOString().substr(0, 10),
      date5: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      menu7: false,
      menu8: false,
      selected: [''],
      selected1: [''],
      selected2: [''],
      dialog: false,
      activeColor: 'red',
      activeColor1: 'white',
      Reefer: true,
      cargo: false,
      ColdTreatement: false,
      GensetExport: false,
      allOversized: false,
      alldetails: false,
      allOversized1: false,
      alldetails1: false,
      tarrifbooking: false,
      Commercialinvoice: '',
      Packinglist: '',
      billoflading: '',
      certificateoforigin: '',
      receiveddatetime: '',
      bookingreference: '',
      salesorderno: '',
      material: '',
      batch: '',
      qtyintons: '',
      stuffinglocation: '',
      shippingline: '',
      termsofshipment: '',
      placeofreceipt: '',
      portofloading: '',
      placeofdelivery: '',
      portofdischarge: '',
      companyname: '',
      companyaddress: '',
      time: '',
      time1: '',
      phoneno: '',
      contact: '',
      companyname1: '',
      companyaddress1: '',
      time2: '',
      phoneno1: '',
      contact1: '',
      containertype: '',
      qty: '',
      commodity: '',
      netwt: '',
      grosswt: '',
      temperature: '',
      noofprobes: '',
      ventilation: '',
      humidity: '',
      imoclass: '',
      uncode: '',
      flashpoint: '',
      unittype: '',
      propershipping: '',
      generalcomments: '',
      imoclass2: '',
      packinggroup: '',
      aggregationstate: '',
      marinepollutant: '',
      ltdqtyofdanggoods: '',
      emergencycontact: '',
      emergencycontact1: '',
      length: '',
      width: '',
      height: '',
      length1: '',
      width1: '',
      height1: '',
      length2: '',
      width2: '',
      height2: '',
      containernumber: '',
      containertype1: '',
      commodity1: '',
      agreedfreedays: '',
      noofpackages: '',
      kindofpackages: '',
      netwtmtons: '',
      grosswtmtons: '',
      tarewtmtons: '',
      vgmwtmtons: '',
      shipperseal: '',
      hscode: '',
      cargodescription: '',
      containernumber1: '',
      containertype2: '',
      commodity2: '',
      agreedfreedays1: '',
      noofpackages1: '',
      kindofpackages1: '',
      netwtmtons1: '',
      grosswtmtons1: '',
      tarewtmtons1: '',
      vgmwtmtons1: '',
      shipperseal1: '',
      hscode1: '',
      cargodescription1: '',
      contractnumber: '',
      contractnumber1: '',
      shipper: '',
      shipperaddress: '',
      consignee: '',
      consigneeaddress: '',
      firstnotifyparty: '',
      firstnotifypartyaddress: '',
      secondnotifyparty: '',
      secondnotifypartyaddress: '',
      contactperson: '',
      generalcomments1: '',
      mobilenumber: '',
      emails: '',
      templatename: '',
      vessel_departure_time: '',
      vessel: '',
      voyage: '',
      document_commercial_invoice: '',
      document_packing_list: '',
      document_bill_of_lading: '',
      certificate_of_origin: '',
      document_received_time: '',
      document_name: ''
    }
  },
  mounted () {
    console.log('bulkbooking page')
  },
  methods: {
    sho1 () {
      this.show1 = true
      this.show2 = false
      this.show3 = false
      this.show4 = false
      this.show5 = false
    },
    sho2 () {
      this.show2 = true
      this.show1 = false
      this.show3 = false
      this.show4 = false
      this.show5 = false
    },
    sho3 () {
      this.show3 = true
      this.show1 = false
      this.show2 = false
      this.show4 = false
      this.show5 = false
    },
    sho4 () {
      this.show4 = true
      this.show1 = false
      this.show2 = false
      this.show3 = false
      this.show5 = false
    },
    sho5 () {
      this.show5 = true
      this.show1 = false
      this.show2 = false
      this.show3 = false
      this.show4 = false
    },
    back () {
      this.$router.push('/Dashboard')
    },
    dashboard () {
      this.dialog = false
      this.$router.push('/Dashboard')
    },
    activate (el) {
      this.active_el = el
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.active_el {
  background-color: #00C853;
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/Customclearancebookingform.vue